import { getItemByLabelFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export function getRecursPaidIntervals(): ISelectItem[] {
  return [
    { id: 1, label: 'Monthly' },
    { id: 4, label: 'Annually' },
    { id: 5, label: '1x' },
    { id: 6, label: 'N/A' },
  ]
}

export const getRecursPaidIntervalByLabel = getItemByLabelFactory(
  getRecursPaidIntervals
)
